import { render, staticRenderFns } from "./ShareNotificationPage.vue?vue&type=template&id=4c6661ea"
import script from "./ShareNotificationPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShareNotificationPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports